<div class="tv-menu" [ngClass]="{'fade-in': isScreens,'fade-out': !isScreens }">
  <div class="tv-menu-top">
    <caremoni-logo-tv></caremoni-logo-tv>
    <div class="space"></div>
    <div class="tv-menu-top-item">
      <span class="tv-menu-top-item-content" [attr.dpad]="DpadZoneType.TV_LAYOUT" [attr.x-dpad]="0" [attr.y-dpad]="0"
        (click)="logout()" id="idLogout"
      >ログアウト</span>
    </div>
  </div>
  <div class="tv-menu-center">
    <div class="tv-menu-center-left">
      <img *ngIf="menuItemSelected.type != MenuType.VIDEO && menuItemSelected.type != MenuType.YOUTUBE && isLoaded"
        class="tv-menu-center-left-img big-thum" src="{{environment.avatarUrl + menuItemSelected.thumbnail}}"
        (error)="onImgError($event)" />
      <p-skeleton *ngIf="!isLoaded" class="big-thum-ske" width="100%" height="100%" />
      <video *ngIf="menuItemSelected.type == MenuType.VIDEO" #videoEl
        [poster]="environment.avatarUrl + menuItemSelected.thumbnail" loop width="100%" height="100%"
        ><source [src]="environment.avatarUrl + menuItemSelected.url" type="video/mp4" />
      </video>
      <div *ngIf="menuItemSelected.type == MenuType.YOUTUBE" #youtubeContainer>
        <img *ngIf="!youtubePlayer" class="tv-menu-center-left-img" src="{{environment.avatarUrl + menuItemSelected.thumbnail}}" />
      </div>
    </div>
    <div class="tv-menu-center-right">
      <div *ngIf="isLoaded" class="tv-menu-center-right-title">{{menuItemSelected.name}}</div>
      <p-skeleton *ngIf="!isLoaded" class="title-ske" width="100%" height="10%" />
      <div *ngIf="isLoaded" class="tv-menu-center-right-decription big-thum">{{menuItemSelected.description}}</div>
      <p-skeleton *ngIf="!isLoaded" class="des-ske" width="100%" height="90%" />
    </div>
  </div>
  <div class="tv-menu-bottom" id="heightScroll">
    <div *ngFor="let group of getVisibleMenuGroups(); trackBy: trackByVisibleMenuGroup" [attr.data-tv-menu-group]="group.dpadIndex">
      <div class="tv-menu-bottom-title">{{group.menu.menuName}}</div>
      <div *ngIf="isLoaded; else groupSkeleton" class="tv-menu-bottom-group">
        <div class="tv-menu-bottom-group-item" *ngFor="let item of group.menu.items; let ilv2 = index; trackBy: trackByItemId"
          style="display: flex; flex-direction: column-reverse;">
          <div class="tv-menu-bottom-group-item-block">
            <p class="tv-menu-bottom-group-item-title text-ellipsis" [innerHTML]="getItemDisplayName(item)"></p>
            <img [src]="getThumbnailUrl(item)" loading="lazy" decoding="async" (click)="changePage(item)" class="tv-menu-bottom-group-item-img"
              [attr.dpad]="DpadZoneType.TV_LAYOUT" [attr.x-dpad]="ilv2" [attr.y-dpad]="group.dpadIndex" (error)="onImgError($event)" />
              <div *ngIf="item.type == MenuType.VIDEO || item.type == MenuType.YOUTUBE" class="tv-menu-bottom-group-item-duration">{{item.duration}}</div>
          </div>
        </div>
      </div>
      <ng-template #groupSkeleton>
        <div class="tv-menu-bottom-group tv-menu-bottom-group-skeleton">
          <div class="tv-menu-bottom-group-item" *ngFor="let _ of groupSkeletonItems">
            <div class="tv-menu-bottom-group-item-block">
              <p-skeleton class="tv-menu-bottom-group-item-title-skeleton" width="120px" height="28px" />
              <p-skeleton class="tv-menu-bottom-group-item-img-skeleton" width="150px" height="84px" />
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div> 
</div>
